module.exports = __webpack_public_path__ + "img/bg09.f0a36ee9.png";